import { EffectivityManagement } from 'src/screens/shared/project/details/effectivity-management/EffectivityManagement'

export const PfPgvEffectivityManagementPage = () => {
  return <EffectivityManagement baseUrl="/pf-pgv" />
}
